class PrivacySettings {
  constructor() {
    this.init();
  }

  init() {
    // Warte bis das DOM geladen ist
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.removeTargetBlank();
      });
    } else {
      this.removeTargetBlank();
    }

    // Für dynamisch geladene Inhalte (wie Vue.js)
    this.observeDOMChanges();
  }

  removeTargetBlank() {
    // Suche nach allen Links mit dem Text "Privacy Settings"
    const links = Array.from(document.querySelectorAll('a'));

    links.forEach(link => {
      if (link.textContent.trim() === 'Privacy Settings') {
        // Entferne das target="_blank" Attribut
        link.removeAttribute('target');

        // Optional: Entferne auch rel="noopener noreferrer" falls vorhanden
        if (link.hasAttribute('rel')) {
          link.removeAttribute('rel');
        }
      }
    });
  }

  observeDOMChanges() {
    // Erstelle einen MutationObserver um DOM-Änderungen zu überwachen
    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver((mutations) => {
        let shouldCheck = false;

        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            shouldCheck = true;
          }
        });

        if (shouldCheck) {
          // Kurze Verzögerung um sicherzustellen, dass der DOM vollständig aktualisiert ist
          setTimeout(() => {
            this.removeTargetBlank();
          }, 100);
        }
      });

      // Beobachte Änderungen im gesamten Dokument
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }
}

export default PrivacySettings;
